import getPersonalListsMappingRequest from 'owa-service/lib/factory/getPersonalListsMappingRequest';
import { runOwsRequestWithMonitor, Feature } from '../../../shared';
import getPersonalListsMappingOperation from 'owa-service/lib/operation/getPersonalListsMappingOperation';
import type PersonalListsMap from 'owa-service/lib/contract/PersonalListsMap';

export default function getEmailToPDLsMap(): Promise<{ [emailAddress: string]: string[] }> {
    return runOwsRequestWithMonitor({
        scenarioName: 'GetEmailToPDLsMapping',
        feature: Feature.PrivateDistributionList,
        operation: () => {
            return getPersonalListsMappingOperation({
                request: getPersonalListsMappingRequest({}),
            });
        },
        transformResponse: personaListsMap => {
            const pdlsMap: PersonalListsMap[] = personaListsMap['PersonListsMapping'];

            return pdlsMap.reduce<{ [emailAddress: string]: string[] }>((pdlMap, listMap): {
                [emailAddress: string]: string[];
            } => {
                pdlMap[listMap.EmailAddress.toLowerCase()] = listMap.PdlList.map(
                    itemId => itemId.Id
                );
                return pdlMap;
            }, {});
        },
    });
}
